module.exports = __webpack_public_path__ + "img/3_banner.518869a0.png";